import { updateWorkbenchRegion } from "../state/regions";
import { WorkbenchRegion, WorkbenchRegions } from "../state/regions.types";

export type ResizeWorkbenchRegionPayload = {
  position: WorkbenchRegion.Position;
  newSize: number;
  newMaxSize?: number;
  newMinSize?: number;
};

/**
 * Change the size of the region at the given position.
 */
export function resizeWorkbenchRegion<
  TLeft extends WorkbenchRegion.Left,
  TBottom extends WorkbenchRegion.Bottom,
  TRight extends WorkbenchRegion.Right,
>(
  state: WorkbenchRegions<TLeft, TBottom, TRight>,
  payload: ResizeWorkbenchRegionPayload,
): WorkbenchRegions<TLeft, TBottom, TRight> {
  return updateWorkbenchRegion(state, payload.position, (draft) => {
    draft.size = payload.newSize;
    draft.maxSize = payload.newMaxSize;
    draft.minSize = payload.newMinSize;
  });
}

export type ToggleWorkbenchRegionPayload = {
  position: WorkbenchRegion.Position;
  /** optionally force this value instead of flipping the current value */
  newIsOpen?: boolean;
};
/**
 * Toggle the open state of the region at the given position.
 */
export function toggleWorkbenchRegion<
  TLeft extends WorkbenchRegion.Left,
  TBottom extends WorkbenchRegion.Bottom,
  TRight extends WorkbenchRegion.Right,
>(
  state: WorkbenchRegions<TLeft, TBottom, TRight>,
  payload: ToggleWorkbenchRegionPayload,
): WorkbenchRegions<TLeft, TBottom, TRight> {
  return updateWorkbenchRegion(state, payload.position, (draft) => {
    draft.isOpen = payload.newIsOpen ?? !draft.isOpen;
  });
}
